(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/helpers/handlebars-helpers.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/helpers/handlebars-helpers.js'); 
(function(Backbone, _, svs) {
  'use strict';

  if (typeof exports === 'object') {
    registerHelpers(require('hbs'));
  } else {
    registerHelpers(Handlebars);
  }

  function registerHelpers(hbs) {
    var toString = Object.prototype.toString,
      functionType = '[object Function]';

    hbs.registerHelper('reverse', function(context, options) {
      var fn = options.fn,
        inverse = options.inverse;
      var i = 99999,
        ret = '',
        data;

      var type = toString.call(context);
      if (type === functionType) {
        context = context.call(this);
      }

      if (options.data) {
        data = Handlebars.createFrame(options.data);
      }

      if (context && typeof context === 'object') {
        if (context instanceof Array) {
          for (i = context.length - 1; i >= 0; i--) {
            if (data) {
              data.index = i;
            }
            ret = ret + fn(context[i], { data: data });
          }
        } else {
          for (var key in context) {
            if (Object.prototype.hasOwnProperty.call(context, key)) {
              if (data) {
                data.key = key;
              }
              ret = ret + fn(context[key], { data: data });
              i = 0;
            }
          }
        }
      }

      if (i > 0) {
        ret = inverse(this);
      }

      return ret;
    });

    hbs.registerHelper('gameClass', function() {
      return svs.tipset.data.gameDefinitions.htmlClass;
    });

    hbs.registerHelper('singleMarkItem', function(mark, sign, options) {
      switch (sign) {
        case 'home':
          return mark == 1 ? options.fn(this) : options.inverse(this);
        case 'draw':
          return mark == 2 ? options.fn(this) : options.inverse(this);
        case 'away':
          return mark == 4 ? options.fn(this) : options.inverse(this);
        default:
          return false;
      }
    });

    hbs.registerHelper('singleBoardNumber', function(boardId) {
      return boardId + 1;
    });

    hbs.registerHelper('increaseIndex', function(index) {
      return index + 1;
    });

    hbs.registerHelper('json', function(context) {
      return JSON.stringify(context);
    });

    hbs.registerHelper('unit', function(context) {
      var unit = 'kr';
      if (svs.tipset.models.play.get('isSingleRow')) {
        if (context && context.size == 1) {
          unit = 'rad';
        } else {
          unit = 'rader';
        }
      }
      return unit;
    });

    hbs.registerHelper('betSelect', function(betButtons, btnLabel) {
      switch (betButtons) {
        case '0':
          return;
        case '1':
          if (btnLabel === '1') {
            return ' btn-bet-selected';
          }
          break;
        case '2':
          if (btnLabel === 'X') {
            return ' btn-bet-selected';
          }
          break;
        case '3':
          if (btnLabel === '1' || btnLabel === 'X') {
            return ' btn-bet-selected';
          }
          break;
        case '4':
          if (btnLabel === '2') {
            return ' btn-bet-selected';
          }
          break;
        case '5':
          if (btnLabel === '1' || btnLabel === '2') {
            return ' btn-bet-selected';
          }
          break;
        case '6':
          if (btnLabel === 'X' || btnLabel === '2') {
            return ' btn-bet-selected';
          }
          break;
        case '7':
          if (btnLabel === '1' || btnLabel === 'X' || btnLabel === '2') {
            return ' btn-bet-selected';
          }
          break;
        default:
      }
    });
    hbs.registerHelper('calendarDate', function(closeTime) {
      var dateString = closeTime.substr(0, 10),
        momentDate = new moment(dateString),
        calendarDate,
        newTitle;

      calendarDate = momentDate.calendar(
        new Date(),

        {
          sameDay: '[idag], D/M (vW)',
          nextDay: '[imorgon], D/M (vW)',
          nextWeek: 'dddd, D/M (vW)',
          sameElse: 'dddd, D/M (vW)'
        }
      );
      newTitle =
        calendarDate.charAt(0).toUpperCase() + calendarDate.substring(1);
      return newTitle;
    });

    hbs.registerHelper('hasEventAnalysis', function(eventAnalyzes, eventNumber, context) {
      if (eventAnalyzes && eventAnalyzes[eventNumber] && eventAnalyzes[eventNumber].length > 0) {
        return context.fn({
          analyzes: eventAnalyzes[eventNumber]
        });
      }
    });
  }
})(Backbone, _, svs);

 })(window);